import { render, staticRenderFns } from "./LoginThresh.vue?vue&type=template&id=77b4896a"
import script from "./LoginThresh.vue?vue&type=script&lang=ts"
export * from "./LoginThresh.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports